export default __webpack_public_path__ + "f984c7dcb0fc8b5e07dc4d5f4ebc7f43.svg";